import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372de28a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import MenuLinkItemContent from "@/components/organisms/mypage/MenuLinkItemContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuAnchorLinkItem',
  props: {
  label: {
    type: String,
    required: false
  },
  href: {
    type: String,
    required: true
  }
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: props.href,
    class: "d-block border-outline-color py-3 menu-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createVNode(MenuLinkItemContent, {
      label: props.label
    }, {
      left: _withCtx(() => [
        _renderSlot(_ctx.$slots, "left")
      ]),
      right: _withCtx(() => [
        _renderSlot(_ctx.$slots, "right")
      ]),
      bottom: _withCtx(() => [
        _renderSlot(_ctx.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["label"])
  ], 8, _hoisted_1))
}
}

})